export enum InboundEmailsRoles {
  MANAGER = 'roles.inboundEmailsManager',
}
